export default __webpack_public_path__ + "static/media/chocChipBiscuits.a85b4517.jpg";